<script>
	import registrationTypes from "../config/registrationTypes";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import ClaimantSomeoneElse from "./ClaimantSomeoneElse.svelte";
	import ClaimantDeceasedEstate from "./ClaimantDeceasedEstate.svelte";

	export let disabled = null;
	export let contactIsExecutor;
	export let registrationType;
	export let claimant;
	export let executors;
	export let estateBeneficiary;
	export let dependantOfDeceased;
	export let relationshipToClaimant;
	export let contactFirstName;
	export let contactSurname;
</script>

<FormRow>
	<FormColumn>
		<h2>Claimant Details</h2>
	</FormColumn>
</FormRow>

<hr class="primary" />

{#if registrationType == registrationTypes.types.SomeoneElse.value}
	<ClaimantSomeoneElse {disabled} bind:claimant />
{:else}
	<ClaimantDeceasedEstate
		{disabled}
		bind:contactIsExecutor
		bind:claimant
		bind:estateBeneficiary
		bind:dependantOfDeceased
		bind:relationshipToClaimant
		bind:executors
		{contactFirstName}
		{contactSurname}
	/>
{/if}
